import CloseCardWithdrawalAccount from './CloseCardWithdrawalAccount';

export default CloseCardWithdrawalAccount;
